import { unbindWork, getAdvertisers } from '@/api/advertiser'
import { verifyBindWorker } from '@/api/open'

export default {
    components: {},
    props: {
        showunBindWorkForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        },
    },
    data() {
        return {
            labelCol: {span: 4},
            wrapperCol: {span: 18},
            roles: [],
            corporations: [],
            loading: false,
            workers: [],
            admins:[],
            refresh: false,
        }
    },
    computed: {
        actType() {
            return '解绑'
        }
    },
    mounted() {    
    },
    methods: {
        getAdvertiser() {
            this.loading = true
         
            if (this.model.media_type) {
                
                getAdvertisers({out_id: this.model.out_id}, this.model.media_type).then(res => {
                    this.loading = false
                   
                    if (res.data.list[0].worker_id != this.model.worker_id) {
                        this.$message.error('该广告主已绑定优化师,绑定的优化师为【'+this.$helper.getItemName(this.workers, res.data.list[0].worker_id)+'】')
                        //关闭的时候，需要刷新
                        this.refresh = true
                        this.model.worker_id = res.data.list[0].worker_id
                    }
                }).catch(() => {
                    this.loading = false
                })
            }
          
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                // 校验是否已绑定优化师
                verifyBindWorker(this.model.id>0?this.model.id:this.model.ids).then(res => {
                    let boundAdvertiserIds = res.data.list || []
                    if (boundAdvertiserIds.length > 0) {
                        let idStr = boundAdvertiserIds.join(', ')
                        this.$confirm({
                            title: '提示',
                            content: `广告主 ID（${idStr}）已绑定优化师，是否继续进行解绑操作？`,
                            okText: '是',
                            cancelText: '否',
                            onOk: () => {
                                console.log('确认解绑优化师！')
                                this.bindWork()
                            },
                            onCancel: () => {
                                // 用户点击否，不做任何处理
                                console.log('取消解绑操作！')
                            }
                        })
                    } else {
                        console.log('直接解绑优化师！')
                        this.bindWork()
                    }
                    
                })
            })
        },
        bindWork() {
            this.loading = true
            console.log(this.model)
            unbindWork(this.model,this.model.id>0?this.model.id:this.model.ids).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('解绑成功')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            if (this.refresh) {
                this.$emit('success')
            }
            this.$emit('update:showunBindWorkForm', false)
        }
    }
}
